
export const keys = {
    all: ["tank-relationships"],
    data: (groupID: number) => [
        ...keys.all,
        "data", {
            groupID,
        }
    ]
};
